import React from 'react'
import styles from './CenterContent.module.css'

export default function CenterContent({ children }) {
	return <div className={styles.CenterContent}>{children}</div>
}
